import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { ComponentGroupResponse } from '@/types/apps/component-group.type';
import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface ComponentGroupServiceInterface {}

type ComponentGroupGraphQLListResponse =
    GqlListResponse<ComponentGroupResponse>;

export class ComponentGroupGraphQLService
    extends BaseService
    implements ComponentGroupServiceInterface
{
    public getEntityName(): string {
        return 'partGroup';
    }

    public getFields(): Record<string, any> {
        return {
            code: true,
            createdBy: true,
            createdDate: true,
            deletedAt: true,
            deletedBy: true,
            description: true,
            id: true,
            isDeleted: true,
            modifiedBy: true,
            modifiedDate: true,
            name: true,
            partCategoryCode: true,
            partCategoryId: true,
            partTypeCode: true,
            partTypeId: true,

            partCategory: {
                code: true,
                id: true,
                name: true,
            },
            partType: {
                code: true,
                id: true,
                name: true,
                partCategoryCode: true,
                partCategoryId: true,
            },
        };
    }

    public async index(
        query: string
    ): Promise<ComponentGroupGraphQLListResponse> {
        return this.fetchGqlList<ComponentGroupGraphQLListResponse>(
            query,
            this.getEntityName()
        );
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('componentGroup', {
            userId: this.getQueryById(),
        });
    }
}
